import ConnectivityOverView from "../views/ConnectivityDashboardView"

export default class ConnectivityProjectOverView extends ConnectivityOverView {
  constructor(props) {
    super(props, "connectivity-project-overview")
  }
}
